module.exports = __webpack_public_path__ + "img/鼎锐联生产运维管理软件.ce193ca9.png";